function checkboxDropdown(el) {
    if(window.globalVariables.templateSuffix == 'club-member' || window.globalVariables.templateSuffix == 'club'){
      var $el = document.querySelectorAll(el);

      function updateStatus(label, result) {
        if (!result.length) {
          label.innerHTML = 'Select Options';
        }
      };

      $el.forEach(element => {
        let $list = element.querySelector('.dropdown-list'),
        $label = element.querySelector('.dropdown-label'),
        $checkAll = element.querySelectorAll('.check-all'),
        result = [];
        /*let $inputs = element.querySelectorAll('.check'),
        defaultChecked = element.querySelectorAll('input[type=checkbox]:checked');*/

        updateStatus($label, result);

        $label.addEventListener('click', (event) => {
          element.classList.toggle('open');
        });

        $checkAll.forEach(checkboxChange => {
          checkboxChange.addEventListener('change', (event) => {

            let $this = event.target,
            checked = $this.checked,
            result = [];

            if(!checked){
              $this.closest(".multiselect-product-dropdown").querySelectorAll(".dropdown-list input[name='dropdown-group-all']").forEach(evt => {
                if(evt.checked == true){
                  result = evt.nextElementSibling.innerText;
                }
              });
            }else{
              result.push($this.nextElementSibling.innerText);
            }

            $label.innerHTML = result;
            updateStatus($label, result);
            element.classList.remove('open');
          });
        });

        document.addEventListener('click', e => {
          let isClickInsideElement = element.contains(e.target);
          if (!isClickInsideElement) {
            element.classList.remove('open');
          }
        });

      });
    }

}